module.exports = __webpack_public_path__ + "fonts/Prometo.49c0e6bf.ttf";